import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PageNotFoundComponent } from 'src/app/shared/components/page-not-found/page-not-found.component';
import { ScenarioComparisonComponent } from './scenario-comparison.component';

const routes: Routes = [
  {
    path: 'scenarioComparison',
    component: ScenarioComparisonComponent,
  },
  { path: '**', component: PageNotFoundComponent}
];

@NgModule({
  declarations: [],
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ScenarioComparisonRoutingModule { }
